import React, { useMemo } from 'react';

// Goldfish component
const Goldfish = () => (
  <div className="fish-goldfish">
    <div className="body">
      <div className="fin-top" />
      <div className="eye" />
    </div>
    <div className="tail" />
  </div>
);

// Tropical fish component
const TropicalFish = () => (
  <div className="fish-tropical">
    <div className="body">
      <div className="fin-top" />
      <div className="fin-bottom" />
      <div className="eye" />
    </div>
    <div className="tail" />
  </div>
);

// Angelfish component
const Angelfish = () => (
  <div className="fish-angel">
    <div className="body">
      <div className="fin-top" />
      <div className="fin-bottom" />
      <div className="eye" />
    </div>
    <div className="tail" />
  </div>
);

// Clownfish component
const Clownfish = () => (
  <div className="fish-clown">
    <div className="body">
      <div className="stripe" />
      <div className="stripe" />
      <div className="stripe" />
      <div className="fin-top" />
      <div className="eye" />
    </div>
    <div className="tail" />
  </div>
);

// Jellyfish component
const Jellyfish = () => (
  <div className="fish-jelly">
    <div className="bell">
      <div className="tentacle" />
      <div className="tentacle" />
      <div className="tentacle" />
      <div className="tentacle" />
      <div className="tentacle" />
      <div className="tentacle" />
    </div>
  </div>
);

const fishComponents = {
  goldfish: Goldfish,
  tropical: TropicalFish,
  angel: Angelfish,
  clown: Clownfish,
  jelly: Jellyfish,
};

export const Fish = ({ 
  type, 
  direction, 
  speed, 
  yPosition, 
  delay, 
  size, 
  yVariation 
}) => {
  const FishComponent = fishComponents[type] || Goldfish;
  
  const style = useMemo(() => ({
    top: `${yPosition}%`,
    '--swim-y': `${yVariation * 0.3}px`,
    '--swim-y-end': `${yVariation}px`,
    animation: `swim-${direction === 'left' ? 'right-to-left' : 'left-to-right'} ${speed}s linear infinite`,
    animationDelay: `-${delay}s`,
    transform: `scale(${size})`,
    zIndex: Math.floor(yPosition),
  }), [direction, speed, yPosition, delay, size, yVariation]);

  return (
    <div className="fish" style={style}>
      <FishComponent />
    </div>
  );
};
